import Calculator from "./Calculator";
import CalculatorEmail from "./Calculator.email";

const CalculatorExecution = {

    init(el) {
        this.el = el.find('.checkbox.special');
        if (!this.el.length) return;

        this.slide = this.el.closest('.content');
        this.numbers = this.slide.find('.checkbox input[type="number"]');
        this.total = this.slide.find('.input.total');
        this.form = el.find('form');
        this.bind();
    },

    bind() {
        this.el.click((evt) => {
            const input = $(evt.currentTarget);
            const number = input.find('input[type="number"]')
            const val = number.val();

            if (input.find('[type="checkbox"]').prop('checked')) {
                input.addClass('active');
                number.val(val).focus().select();
            } else {
                input.removeClass('active');
                number.val(0);
            }

            this.calculate();
        })

        this.numbers.change((evt) => {
            this.calculate();
        })

        this.numbers.focus((evt) => evt.currentTarget.select());
    },

    calculate() {
        let sum = 0;
        let save3a = 0;
        let save3b = 0;
        let save5a = 0;
        let save5b = 0;

        this.numbers.each((i, el) => {
            const input = $(el).parent('.input');
            const val = $(el).val() ? parseInt($(el).val()) : 0;
            const s3a = parseInt(input.attr('save3a')) / 100;
            const s3b = parseInt(input.attr('save3b')) / 100;
            const s5a = parseInt(input.attr('save5a')) / 100;
            const s5b = parseInt(input.attr('save5b')) / 100;

            sum += val;
            save3a += (val / 100) * s3a;
            save3b += (val / 100) * s3b;
            save5a += (val / 100) * s5a;
            save5b += (val / 100) * s5b;
        })

        save3a = Math.round(save3a * 100)
        save3b = Math.round(save3b * 100)
        save5a = Math.round(save5a * 100)
        save5b = Math.round(save5b * 100)

        this.total.find('.sum input').val(sum);

        Calculator.outcome.find('.save3a').attr('end', save3a);
        Calculator.outcome.find('.save3b').attr('end', save3b);
        Calculator.outcome.find('.save5a').attr('end', save5a);
        Calculator.outcome.find('.save5b').attr('end', save5b);

        this.form.find('[name="save3a"]').val(save3a);
        this.form.find('[name="save3b"]').val(save3b);
        this.form.find('[name="save5a"]').val(save5a);
        this.form.find('[name="save5b"]').val(save5b);
        this.form.find('[name="fok"]').val('qqq');

        if (sum === 100) {
            this.total.find('.indicator').removeClass('error').addClass('success');
        } else {
            this.total.find('.indicator').removeClass('success').addClass('error');
        }
    }
}

export default CalculatorExecution;